import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { AdminPatchPlanTierRequest, PlanCode } from '@naya/shared'
import { adminApi } from '../adminApi.js'
import type { PlanTierRow } from '../types.js'
import { planTiersKey } from './useTenants.js'

interface PlanTierResponse {
  plan_tier: PlanTierRow
}

/**
 * Edits one plan tier's settings (price, limits, capabilities). The tier
 * identity (starter/pro/business) is the path param and is never editable.
 */
export function useUpdatePlanTier() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: { tier: PlanCode } & AdminPatchPlanTierRequest) => {
      const { tier, ...patch } = vars
      return adminApi.patch<PlanTierResponse>(`/plan-tiers/${tier}`, patch)
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: planTiersKey })
    },
  })
}
